// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Eye = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Eye = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Eye = _exports.Eye = function Eye(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.6962 8.44861C16.6021 6.61611 14.1461 3.54199 10.0003 3.54199C5.85446 3.54199 3.39854 6.61611 2.30437 8.44861C1.73188 9.40528 1.73188 10.5945 2.30437 11.552C3.39854 13.3845 5.85446 16.4587 10.0003 16.4587C14.1461 16.4587 16.6021 13.3845 17.6962 11.552C18.2687 10.5945 18.2687 9.40611 17.6962 8.44861ZM16.6236 10.9104C15.6653 12.5154 13.5295 15.2087 10.0003 15.2087C6.47113 15.2087 4.3353 12.5162 3.37697 10.9104C3.04197 10.3487 3.04197 9.65114 3.37697 9.08948C4.3353 7.48448 6.47113 4.79118 10.0003 4.79118C13.5295 4.79118 15.6653 7.48364 16.6236 9.08948C16.9595 9.65198 16.9595 10.3487 16.6236 10.9104ZM10.0003 6.45866C8.04696 6.45866 6.45863 8.04783 6.45863 10.0003C6.45863 11.9528 8.04696 13.542 10.0003 13.542C11.9536 13.542 13.542 11.9528 13.542 10.0003C13.542 8.04783 11.9536 6.45866 10.0003 6.45866ZM10.0003 12.292C8.73613 12.292 7.70863 11.2645 7.70863 10.0003C7.70863 8.73616 8.73613 7.70866 10.0003 7.70866C11.2645 7.70866 12.292 8.73616 12.292 10.0003C12.292 11.2645 11.2645 12.292 10.0003 12.292Z",
      fill: "currentColor"
    }));
  };
});
